export class PathConstraintData {
    constructor() {
        this.bones = [];
    }
}
